import { NO_BOM } from 'shared/product_tabs/tab_parts/data/BomStatus';
import { ACTUAL } from 'shared/product_tabs/tab_parts/data/QuoteType';
import { PCB_PARTS_ID } from 'shared/product_tabs/tab_parts/data/BomConstants';

const bom = {
  id: null,
  name: '',
  revision: '',
  version: '',
  board_qtys: [null],
  selected_board_qty: null,
  bom_file: null,
  bom_status: NO_BOM,
  bom_line_items: [],
  base_totals: {},
  markups: {},
  shipping: {},
  tariffs: {},
  totals: {},
  quote_type: ACTUAL,
  preferences: [],
  line_item_id: null,
  product_quote_number: null,
  currentVariant: PCB_PARTS_ID,
  saved: false,
};

const data_for_import = {
  header: null,
  first_row: null,
  ref_des_separator: ',',
  ref_des_range_separator: '-',
  bom_parameters: [],
  workbook: [],
};

const quote_progress = {
  step: 0,
  total_steps: 0,
  current_pn: '',
};

const view = {
  substitutes: [],
  changed_zip_file: false,
  uploaded_zip_file: false,
  destroy: false,
  loading: false,
  messages: [],
  show_modal: false,
  zip_file_input_id: null,
  fabrication_slug: '',
  directory: {},
  bom_selected: false,
  show_bom_selection: false,
  available_bom_in_zip: false,
};

const state = {
  ...bom,
  data_for_import: { ...data_for_import },
  quote_progress: { ...quote_progress },
  view: { ...view },
};

export default state;
